<template>
  <div class="footer-container">
    <div class="footer">
      <div class="logofooter"></div>
      <div class="info">
        <h3>{{ $t('footer.moreInfo') }}</h3>
        <span>{{ $t('footer.infoDescription') }}</span>
        <br />
        <a class="link" href="https://maps.app.goo.gl/2AYSsmrSx5cBayG89" target="_blank">
          {{ $t('footer.findUs') }}
        </a>
        <a
          class="link"
          href="../../public/Política de Tratamiento de Datos Personales.pdf"
          target="_blank"
        >
          Politica de tratamiento de datos.
        </a>
        <div class="admin-section">
          <button class="admin-login-btn" @click="handleAdminLogin">
            <span class="material-symbols-outlined">admin_panel_settings</span>
            {{ isAuthenticated() ? 'Panel Admin' : 'Acceso Admin' }}
          </button>
        </div>

      </div>

      <div class="contact">
        <h3>{{ $t('footer.contact') }}</h3>

        <span class="iconic"
          ><span class="material-symbols-outlined"> mail </span>Info@fourin.co</span
        >
        <span class="iconic"
          ><span class="material-symbols-outlined"> call </span>+57 300 6908197</span
        >
        <br />
        <h3>{{ $t('footer.followUs') }}</h3>
        <a class="link" href="https://co.linkedin.com/company/fourin-sas" target="_blank">
          Fourin SAS - Linkedin
        </a>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useAuth } from '../composables/useAuth'

const router = useRouter()
const { isAuthenticated } = useAuth()

const handleAdminLogin = () => {
  if (isAuthenticated()) {
    // Si está logueado, ir al panel de administración
    router.push('/admin')
  } else {
    // Si no está logueado, ir al login
    router.push('/login')
  }
}
</script>

<style>
.iconic {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.iconic span {
  margin: 0px 5px;
}

.admin-section {
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.admin-section h3 {
  font-weight: 200;
  font-size: 24px;
}

.admin-login-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.admin-login-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.admin-login-btn .material-symbols-outlined {
  font-size: 18px;
}
.link {
  color: white;
  text-decoration: underline;

  cursor: pointer;
}

.link:hover {
  color: #f2f2f2;
  text-decoration: none;
}
.contact {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin: 2em;
}
.contact h3 {
  font-weight: 200;
  font-size: 36px;
}
.info h3 {
  font-weight: 200;
  font-size: 36px;
}
.info {
  width: 34%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin: 2em;
}
.logofooter {
  background-image: url(../assets/images/logofooter.png);
  width: 130px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0px 4em;
}
.footer {
  background: linear-gradient(17deg, #0055c3 21%, rgba(0, 212, 255, 1) 100%);
  color: white;
  text-align: center;
  padding: 10px;
  width: 100%;
  height: 400px;
  display: flex;
}



@media (width < 768px) {
  .footer {
    height: auto;
    display: flex;
    align-items: center;
  }
  .info {
    display: none;
    width: auto;
    margin: 1.5em;
  }
  .info span {
    display: none;
  }
  h3 {
    font-size: 14px !important;
  }
  .contact {
    margin: 2em 0em;
  }

  .admin-section {
    margin-top: 15px;
    padding-top: 15px;
  }

  .admin-section h3 {
    font-size: 18px !important;
  }

  .admin-login-btn {
    padding: 8px 12px;
    font-size: 12px;
  }
  .logofooter {
    width: 130px;
    background-size: contain;
    background-position: left;
    background-repeat: no-repeat;
    margin: 10px 0px 0px 1.5em;
    height: 100px;
  }
}
</style>
